<section>
  <div class="modal-main-wrapper">
    <div class="modal-close" (click)="onNoClick()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
          fill="#2708C5"
        />
      </svg>
    </div>

    <div class="header">
      <h2>Activity</h2>
    </div>

    <div class="main-form-wrapper">
      <form [formGroup]="activityForm">
        <div class="form-wrapper-main">
          <div>
            <mat-form-field>
              <mat-label>Activity Type</mat-label>
              <mat-select formControlName="actionType">
                <mat-option value="DriverAssigned">Driver Assigned</mat-option>
                <mat-option value="DriverChanged">Driver Changed</mat-option>
                <mat-option value="PickupScheduled"
                  >Pickup Scheduled</mat-option
                >
                <mat-option value="PickupCompleted"
                  >Pickup Completed</mat-option
                >
                <mat-option value="SubmissionCompleted"
                  >Submission Completed</mat-option
                >
                <mat-option value="DocumentRejected"
                  >Document Rejected</mat-option
                >
                <mat-option value="ResubmissionScheduled"
                  >Resubmission Scheduled</mat-option
                >
                <mat-option value="CustomerContacted"
                  >Customer Contacted</mat-option
                >
                <mat-option value="CustomerUnreachable"
                  >Customer Unreachable</mat-option
                >
                <mat-option value="MeetingScheduled"
                  >Meeting Scheduled</mat-option
                >
                <mat-option value="CallbackRequested"
                  >Callback Requested</mat-option
                >
                <mat-option value="FileUploaded">File Uploaded</mat-option>
                <mat-option value="FileRemoved">File Removed</mat-option>
                <mat-option value="DocVerified">Doc Verified</mat-option>
                <mat-option value="DocRejected">Doc Rejected</mat-option>
                <mat-option value="Rescheduled">Rescheduled</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-error
              *ngIf="
              activityForm.get('actionType')!.touched &&
              activityForm.get('actionType')!.hasError('required')
            "
              >Activity Type is required.</mat-error
            >
          </div>
          <div>
            <mat-form-field>
              <mat-label>message</mat-label>
              <textarea
                matInput
                placeholder="Enter a message"
                formControlName="message"
              ></textarea>
            </mat-form-field>
          </div>
          <div *ngIf="activityForm.get('actionType')?.value === 'DriverAssigned' || activityForm.get('actionType')?.value === 'DriverChanged'">
            <mat-form-field>
              <mat-label>Assign Driver</mat-label>
              <mat-select formControlName="performerId">
                <mat-option *ngFor="let driver of drivers?.employees" [value]="driver?.id">
                  {{ driver?.firstName + ' ' + driver?.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="btnWrapperMain">
          <button class="cmn-add-btn" (click)="onSubmit()">Add</button>
          <button class="cmn-cancel-btn">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</section>
